export const escapeHtml = (value) => {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};

export const formatYen = (value) => {
  return `￥${Number(value || 0).toLocaleString()}`;
};

export const buildMailLayoutHtml = ({
  title,
  lead = "",
  customerName = "",
  contentHtml = "",
  accentColor = "#1f4e79",
}) => {
  return `<!DOCTYPE html>
<html lang="ja">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${escapeHtml(title)}</title>
</head>
<body style="margin:0; padding:0; background:#f7f7f7; font-family:Arial,'Hiragino Kaku Gothic ProN','Yu Gothic',sans-serif; color:#333;">
  <div style="max-width:700px; margin:0 auto; padding:30px 15px;">
    <div style="background:#ffffff; border:1px solid #e5e5e5; border-radius:10px; overflow:hidden;">
      <div style="background:${accentColor}; color:#ffffff; padding:20px 24px;">
        <h1 style="margin:0; font-size:22px;">${escapeHtml(title)}</h1>
        ${
          lead
            ? `<p style="margin:8px 0 0; font-size:13px; opacity:0.9;">${escapeHtml(lead)}</p>`
            : ""
        }
      </div>

      <div style="padding:24px; line-height:1.8; font-size:14px;">
        <p style="margin:0 0 16px;">${escapeHtml(customerName)} 様</p>
        ${contentHtml}

        <hr style="border:none; border-top:1px solid #e5e5e5; margin:24px 0;">

        <p style="margin:0 0 8px;">尚、ご不明な点がございましたら、お気軽にお問合せ下さい。</p>
        <p style="margin:0 0 16px;">
          ▽その他お問い合わせはコチラ▽<br>
          <a href="https://www.pasomaru.co.jp/contact" style="color:#1a73e8; text-decoration:none;">
            https://www.pasomaru.co.jp/contact
          </a>
        </p>

        <div style="font-size:13px; color:#555; line-height:1.7;">
          <div>ぱそまる</div>
          <div>pasomaruhobby@pasomaru.co.jp</div>
          <div>
            <a href="https://www.pasomaru.co.jp" style="color:#1a73e8; text-decoration:none;">
              https://www.pasomaru.co.jp
            </a>
          </div>
          <div>〒556-0005</div>
          <div>大阪府大阪市浪速区日本橋4-15-14</div>
        </div>
      </div>
    </div>
  </div>
</body>
</html>`;
};

export const buildPurchaseDetailBlocks = ({ details, isPrizeOrLowPriceKuji }) => {
  const groupedPrizeItems = [];
  const groupedPrizeDisposalItems = [];
  const normalItems = [];

  let hasPrizeBoxDamage = false;

  const buildMetaText = ({ conditionLabel, boxConditionLabel, accessoryLabel }) => {
    const parts = [];

    if (conditionLabel) {
      if (conditionLabel === "買取不可") {
        parts.push("買取不可");
      } else {
        parts.push(`状態:${conditionLabel}`);
      }
    }

    if (boxConditionLabel) {
      parts.push(`箱:${boxConditionLabel}`);
    }

    if (accessoryLabel) {
      parts.push(`${accessoryLabel}`);
    }

    return parts.length > 0 ? `（${parts.join(" / ")}）` : "";
  };

  const buildMetaHtml = ({ conditionLabel, boxConditionLabel, accessoryLabel }) => {
    const parts = [];

    if (conditionLabel) {
      if (conditionLabel === "買取不可") {
        parts.push("買取不可");
      } else {
        parts.push(`状態:${conditionLabel}`);
      }
    }

    if (boxConditionLabel) {
      parts.push(`箱:${boxConditionLabel}`);
    }

    if (accessoryLabel) {
      parts.push(`付属品:${accessoryLabel}`);
    }

    if (parts.length === 0) return "";

    return `<div style="margin-top:4px; font-size:12px; color:#666;">${parts
      .map((part) => escapeHtml(part))
      .join(" / ")}</div>`;
  };

  for (const detail of details) {
    const quantity = Number(detail.quantity || 0);
    const conditionId = Number(detail?.condition?.id || 0);
    const conditionName = detail?.condition?.name || "";
    const boxCondition = detail?.box_condition || "";
    const accessoryName = detail?.accessories?.name || "";

    const title =
      detail?.item?.item_name ||
      detail?.item?.title ||
      detail?.item_name ||
      "商品名未設定";

    const isGroupedTarget = isPrizeOrLowPriceKuji(detail);
    const isDisposal = conditionId === 7 || conditionName === "買取不可";

    const normalizedItem = {
      title,
      quantity,
      subtotal: isDisposal ? 0 : Number(detail.subtotal || 0),
      conditionLabel: conditionName,
      boxConditionLabel: boxCondition,
      accessoryLabel: accessoryName,
    };

    if (isGroupedTarget) {
      if (isDisposal) {
        groupedPrizeDisposalItems.push(normalizedItem);
      } else {
        if (boxCondition === "箱傷み" || boxCondition === "箱破損") {
          hasPrizeBoxDamage = true;
        }
        groupedPrizeItems.push(normalizedItem);
      }
    } else {
      normalItems.push(normalizedItem);
    }
  }

  const normalLines = normalItems.map((item) => {
    const metaText = buildMetaText(item);
    return `・${item.title}　${item.quantity}点　${formatYen(item.subtotal)}${metaText}`;
  });

  const normalRowsHtml = normalItems
    .map((item) => {
      return `
        <tr>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; vertical-align:top;">
            <div style="font-weight:bold; color:#333;">${escapeHtml(item.title)}</div>
            ${buildMetaHtml(item)}
          </td>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:center; white-space:nowrap;">${item.quantity}点</td>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:right; white-space:nowrap;">${formatYen(item.subtotal)}</td>
        </tr>
      `;
    })
    .join("");

  const groupedPrizeCount = groupedPrizeItems.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );

  const groupedPrizeAmount = groupedPrizeItems.reduce(
    (sum, item) => sum + Number(item.subtotal || 0),
    0
  );

  const groupedPrizeDisposalCount = groupedPrizeDisposalItems.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );

  const groupedPrizeDisposalAmount = groupedPrizeDisposalItems.reduce(
    (sum, item) => sum + Number(item.subtotal || 0),
    0
  );

  const prizeLine =
    groupedPrizeCount > 0
      ? `・プライズ（セットの場合は1点換算）　${groupedPrizeCount}点　${formatYen(groupedPrizeAmount)}${
          hasPrizeBoxDamage ? "（箱傷みによる減額有り）" : ""
        }`
      : "";

  const prizeDisposalLine =
    groupedPrizeDisposalCount > 0
      ? `・プライズ買取不可商品　${groupedPrizeDisposalCount}点　${formatYen(groupedPrizeDisposalAmount)}`
      : "";

  const groupedRowsHtml = `
    ${
      groupedPrizeCount > 0
        ? `
        <tr>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; vertical-align:top;">
            <div style="font-weight:bold; color:#333;">プライズ（セットの場合は1点換算）</div>
            ${
              hasPrizeBoxDamage
                ? `<div style="margin-top:4px; font-size:12px; color:#666;">箱傷みによる減額有り</div>`
                : ""
            }
          </td>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:center; white-space:nowrap;">${groupedPrizeCount}点</td>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:right; white-space:nowrap;">${formatYen(groupedPrizeAmount)}</td>
        </tr>
      `
        : ""
    }
    ${
      groupedPrizeDisposalCount > 0
        ? `
        <tr>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; vertical-align:top;">
            <div style="font-weight:bold; color:#333;">プライズ買取不可商品</div>
          </td>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:center; white-space:nowrap;">${groupedPrizeDisposalCount}点</td>
          <td style="padding:10px 12px; border-bottom:1px solid #eee; text-align:right; white-space:nowrap;">${formatYen(groupedPrizeDisposalAmount)}</td>
        </tr>
      `
        : ""
    }
  `;

  const detailLines = [
    ...normalLines,
    ...(prizeLine ? [prizeLine] : []),
    ...(prizeDisposalLine ? [prizeDisposalLine] : []),
  ];

  const detailBlock =
    detailLines.length > 0
      ? `━━━━━━━━━━━━━━━━━━━━━━━━
査定明細
━━━━━━━━━━━━━━━━━━━━━━━━
${detailLines.join("\n")}
━━━━━━━━━━━━━━━━━━━━━━━━`
      : "";

  const detailTableHtml =
    detailLines.length > 0
      ? `
        <div style="margin:20px 0 16px;">
          <div style="background:#f1f5f9; border-left:4px solid #1f4e79; padding:10px 12px; font-weight:bold; font-size:16px;">
            査定明細
          </div>
          <table style="width:100%; border-collapse:collapse; margin-top:10px; font-size:14px;">
            <thead>
              <tr>
                <th style="text-align:left; padding:10px 12px; background:#fafafa; border-bottom:1px solid #ddd;">商品名 / 状態</th>
                <th style="text-align:center; padding:10px 12px; background:#fafafa; border-bottom:1px solid #ddd; white-space:nowrap;">点数</th>
                <th style="text-align:right; padding:10px 12px; background:#fafafa; border-bottom:1px solid #ddd; white-space:nowrap;">金額</th>
              </tr>
            </thead>
            <tbody>
              ${normalRowsHtml}
              ${groupedRowsHtml}
            </tbody>
          </table>
        </div>
      `
      : "";

  const detailSubtotal =
    normalItems.reduce((sum, item) => sum + Number(item.subtotal || 0), 0) +
    groupedPrizeAmount +
    groupedPrizeDisposalAmount;

  return {
    detailBlock,
    detailTableHtml,
    detailSubtotal,
  };
};

export const buildAssessmentPendingMailBody = ({
  customerName,
  detailBlock,
  detailSubtotal = 0,
  totalAmount,
  purchaseBonus,
  shippingAdjustment,
}) => {
  return `━━━━━━━━━━━━━━━━━━━━━━━━
買取金額のお知らせ
━━━━━━━━━━━━━━━━━━━━━━━━

${customerName} 様

当店をご利用頂き、誠に有難うございます。

◇◇◇◇◇◇◇◇◇◇ 注意！！ ◇◇◇◇◇◇◇◇◇◇◇◇◇
本メール送信日より3日以内のお手続きをお願い致します。
期間を過ぎますと再査定となりますので、予めご了承下さい。
◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇◇

■■お送り頂いた商品の、買取査定結果です■■
${detailBlock || ""}
合計額 ${formatYen(detailSubtotal)}
買取増額 ${formatYen(purchaseBonus)}
送料負担超過分 ${formatYen(shippingAdjustment)}

買取合計 ${formatYen(totalAmount)}
------------------------------------------------
------------------------------------------------
◇◇◇ ↓買取承認手続きをお願いいたします↓ ◇◇◇

□上記内容にてお手続きさせていただきます。
下記アドレスより承諾・キャンセル等のお手続きをお願いいたします。
https://www.pasomaru.co.jp/member/mypage
※恐れ入りますが、キャンセルによるご返送料は、お客様負担となっております。

□買取申し込みのメールでご連絡させていただいておりますが、
まとめて査定させていただいている商品は、個別キャンセル等は行えません。
例）買取価格〇〇円までの商品だけキャンセルして下さい。
全て買取か全てキャンセルのどちらかとなります。`;
};

export const buildAssessmentPendingMailHtml = ({
  customerName,
  detailTableHtml,
  detailSubtotal = 0,
  totalAmount,
  purchaseBonus,
  shippingAdjustment,
}) => {
  const contentHtml = `
    <p style="margin:0 0 16px;">当店をご利用頂き、誠に有難うございます。</p>

    <div style="margin:0 0 20px; padding:14px 16px; background:#fff8e1; border:1px solid #f0d98a; border-radius:8px; color:#7a5d00;">
      <div style="font-weight:bold; margin-bottom:6px;">注意</div>
      <div>本メール送信日より3日以内のお手続きをお願い致します。<br>期間を過ぎますと再査定となりますので、予めご了承下さい。</div>
    </div>

    <p style="margin:0 0 12px; font-weight:bold;">お送り頂いた商品の、買取査定結果です。</p>

    ${detailTableHtml}

    <div style="margin:20px 0; border:1px solid #e5e5e5; border-radius:8px; overflow:hidden;">
      <table style="width:100%; border-collapse:collapse; font-size:14px;">
        <tr>
          <th style="text-align:left; padding:10px 12px; background:#fafafa; border-bottom:1px solid #eee;">合計額</th>
          <td style="text-align:right; padding:10px 12px; border-bottom:1px solid #eee;">${formatYen(detailSubtotal)}</td>
        </tr>
        <tr>
          <th style="text-align:left; padding:10px 12px; background:#fafafa; border-bottom:1px solid #eee;">買取増額</th>
          <td style="text-align:right; padding:10px 12px; border-bottom:1px solid #eee;">${formatYen(purchaseBonus)}</td>
        </tr>
        <tr>
          <th style="text-align:left; padding:10px 12px; background:#fafafa; border-bottom:1px solid #eee;">送料負担超過分</th>
          <td style="text-align:right; padding:10px 12px; border-bottom:1px solid #eee;">${formatYen(shippingAdjustment)}</td>
        </tr>
        <tr>
          <th style="text-align:left; padding:12px; background:#f1f5f9; font-size:15px;">買取合計</th>
          <td style="text-align:right; padding:12px; background:#f1f5f9; font-size:16px; font-weight:bold;">${formatYen(totalAmount)}</td>
        </tr>
      </table>
    </div>

    <div style="margin:24px 0; padding:16px; background:#f8fbff; border:1px solid #d7e7f7; border-radius:8px;">
      <div style="font-weight:bold; margin-bottom:10px;">買取承認手続きをお願いいたします</div>
      <p style="margin:0 0 12px;">上記内容にてお手続きさせていただきます。<br>下記アドレスより承諾・キャンセル等のお手続きをお願いいたします。</p>
      <p style="margin:0 0 12px;">
        <a href="https://www.pasomaru.co.jp/member/mypage" style="color:#1a73e8; text-decoration:none;">
          https://www.pasomaru.co.jp/member/mypage
        </a>
      </p>
      <p style="margin:0 0 12px;">※恐れ入りますが、キャンセルによるご返送料は、お客様負担となっております。</p>
      <p style="margin:0;">
        まとめて査定させていただいている商品は、個別キャンセル等は行えません。<br>
        例）買取価格〇〇円までの商品だけキャンセルして下さい。<br>
        全て買取か全てキャンセルのどちらかとなります。
      </p>
    </div>
  `;

  return buildMailLayoutHtml({
    title: "買取金額のお知らせ",
    lead: "査定結果とお手続きのご案内",
    customerName,
    contentHtml,
    accentColor: "#1f4e79",
  });
};

export const buildDirectConfirmMailBody = ({
  customerName,
  detailBlock,
  detailSubtotal = 0,
  totalAmount,
  purchaseBonus,
  shippingAdjustment,
}) => {
  return `━━━━━━━━━━━━━━━━━━━━━━━━
買取金額のお知らせ
━━━━━━━━━━━━━━━━━━━━━━━━

${customerName} 様

当店をご利用頂き、誠に有難うございます。

■■お送り頂いた商品の、買取査定結果です■■
${detailBlock || ""}
合計額 ${formatYen(detailSubtotal)}
買取増額 ${formatYen(purchaseBonus)}
送料負担超過分 ${formatYen(shippingAdjustment)}

買取合計 ${formatYen(totalAmount)}
------------------------------------------------
------------------------------------------------
□お客様はスピードタイプとなっておりますので、
上記内容にてお手続きさせていただきます。
※基本は当メール翌日のお手続きとなります。`;
};

export const buildDirectConfirmMailHtml = ({
  customerName,
  detailTableHtml,
  detailSubtotal = 0,
  totalAmount,
  purchaseBonus,
  shippingAdjustment,
}) => {
  const contentHtml = `
    <p style="margin:0 0 16px;">当店をご利用頂き、誠に有難うございます。</p>

    <p style="margin:0 0 12px; font-weight:bold;">お送り頂いた商品の、買取査定結果です。</p>

    ${detailTableHtml}

    <div style="margin:20px 0; border:1px solid #e5e5e5; border-radius:8px; overflow:hidden;">
      <table style="width:100%; border-collapse:collapse; font-size:14px;">
        <tr>
          <th style="text-align:left; padding:10px 12px; background:#fafafa; border-bottom:1px solid #eee;">合計額</th>
          <td style="text-align:right; padding:10px 12px; border-bottom:1px solid #eee;">${formatYen(detailSubtotal)}</td>
        </tr>
        <tr>
          <th style="text-align:left; padding:10px 12px; background:#fafafa; border-bottom:1px solid #eee;">買取増額</th>
          <td style="text-align:right; padding:10px 12px; border-bottom:1px solid #eee;">${formatYen(purchaseBonus)}</td>
        </tr>
        <tr>
          <th style="text-align:left; padding:10px 12px; background:#fafafa; border-bottom:1px solid #eee;">送料負担超過分</th>
          <td style="text-align:right; padding:10px 12px; border-bottom:1px solid #eee;">${formatYen(shippingAdjustment)}</td>
        </tr>
        <tr>
          <th style="text-align:left; padding:12px; background:#f1f5f9; font-size:15px;">買取合計</th>
          <td style="text-align:right; padding:12px; background:#f1f5f9; font-size:16px; font-weight:bold;">${formatYen(totalAmount)}</td>
        </tr>
      </table>
    </div>

    <div style="margin:24px 0; padding:16px; background:#f8fbff; border:1px solid #d7e7f7; border-radius:8px;">
      <div style="font-weight:bold; margin-bottom:10px;">スピードタイプでのお手続きについて</div>
      <p style="margin:0;">
        お客様はスピードタイプとなっておりますので、上記内容にてお手続きさせていただきます。<br>
        ※基本は当メール翌日のお手続きとなります。
      </p>
    </div>
  `;

  return buildMailLayoutHtml({
    title: "買取金額のお知らせ",
    lead: "査定結果のご案内",
    customerName,
    contentHtml,
    accentColor: "#1f4e79",
  });
};

export const buildPurchaseConfirmedMailBody = ({
  customerName,
  purchaseNumber,
  totalAmount,
}) => {
  return `━━━━━━━━━━━━━━━━━━━━━━━━
買取確定のご案内
━━━━━━━━━━━━━━━━━━━━━━━━

${customerName} 様

当店をご利用頂き、誠に有難うございます。

買取番号 ${purchaseNumber} につきまして、
ご承諾を確認いたしましたので、買取を確定いたしました。

確定金額：${formatYen(totalAmount)}

振込手続きを進めてまいりますので、今しばらくお待ちください。
よろしくお願いいたします。`;
};

export const buildPurchaseConfirmedMailHtml = ({
  customerName,
  purchaseNumber,
  totalAmount,
}) => {
  const contentHtml = `
    <p style="margin:0 0 16px;">当店をご利用頂き、誠に有難うございます。</p>

    <div style="margin:0 0 20px; padding:16px; background:#f8fbff; border:1px solid #d7e7f7; border-radius:8px;">
      <div style="font-weight:bold; margin-bottom:8px; font-size:16px;">買取確定のご案内</div>
      <p style="margin:0 0 10px;">
        買取番号 <strong>${escapeHtml(purchaseNumber)}</strong> につきまして、<br>
        ご承諾を確認いたしましたので、買取を確定いたしました。
      </p>
      <p style="margin:0; font-size:16px; font-weight:bold;">
        確定金額：${formatYen(totalAmount)}
      </p>
    </div>

    <p style="margin:0 0 16px;">
      振込手続きを進めてまいりますので、今しばらくお待ちください。<br>
      よろしくお願いいたします。
    </p>
  `;

  return buildMailLayoutHtml({
    title: "買取確定のご案内",
    lead: "ご承諾確認後のお手続きについて",
    customerName,
    contentHtml,
    accentColor: "#1f4e79",
  });
};

export const buildPaymentCompletedMailBody = ({
  customerName,
  purchaseNumber,
  totalAmount,
}) => {
  return `━━━━━━━━━━━━━━━━━━━━━━━━
送金手続き完了のご案内
━━━━━━━━━━━━━━━━━━━━━━━━

${customerName} 様

当店をご利用頂き、誠に有難うございます。

買取番号 ${purchaseNumber} の送金手続きが完了いたしました。

送金金額：${formatYen(totalAmount)}

この度はご利用ありがとうございました。
またのご利用をお待ちしております。`;
};

export const buildPaymentCompletedMailHtml = ({
  customerName,
  purchaseNumber,
  totalAmount,
}) => {
  const contentHtml = `
    <p style="margin:0 0 16px;">当店をご利用頂き、誠に有難うございます。</p>

    <div style="margin:0 0 20px; padding:16px; background:#f8fbff; border:1px solid #d7e7f7; border-radius:8px;">
      <div style="font-weight:bold; margin-bottom:8px; font-size:16px;">送金手続き完了のご案内</div>
      <p style="margin:0 0 10px;">
        買取番号 <strong>${escapeHtml(purchaseNumber)}</strong> の送金手続きが完了いたしました。
      </p>
      <p style="margin:0; font-size:16px; font-weight:bold;">
        送金金額：${formatYen(totalAmount)}
      </p>
    </div>

    <p style="margin:0 0 16px;">
      この度はご利用ありがとうございました。<br>
      またのご利用をお待ちしております。
    </p>
  `;

  return buildMailLayoutHtml({
    title: "送金手続き完了のご案内",
    lead: "お振込完了のお知らせ",
    customerName,
    contentHtml,
    accentColor: "#1f4e79",
  });
};